import { z } from "zod";
const zLanguageCode = z.enum([
    "en",
    "uk",
    "de",
    "sk",
    "ru"
]);
const LanguageCode = zLanguageCode.Enum;
const DEFAULT_LANGUAGE_CODE = LanguageCode.de;
export { DEFAULT_LANGUAGE_CODE, LanguageCode, zLanguageCode };

//# sourceMappingURL=language.js.map